<mat-card class="cardWithShadow">
    <mat-card-content>
        <div class="container_button_company" style="margin-bottom: 15px;">
            <mat-card-title style="text-align: center;">
                Cotizacion <span style="background-color: #f1f1f1; border-radius: 12px; padding: 5px;">{{ simulacion.code }}</span>
            </mat-card-title><br>
        </div>

        <div style="text-align: center;" *ngIf="dataSource.data.length == 0">
            <h3>No Se Encontararon Productos</h3>
        </div>

        <div class="overflow-table" [ngClass]="{ oculto: dataSource.data.length == 0 }">
            <table mat-table matSort [dataSource]="dataSource" multiTemplateDataRows>

                <ng-container matColumnDef="ver">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef class="mobile-column">
                      Ver
                    </th>
                    <td mat-cell *matCellDef="let element" class="mobile-column">
                      <h6> 
                        <mat-icon *ngIf="simulacion.statusId!=-7 || !element.discountPendingApproval" (click)="openRisolutionDiscount(element, 1)">open_in_new</mat-icon>
                        <mat-icon *ngIf="simulacion.statusId==-7 && element.discountPendingApproval" (click)="openRisolutionDiscount(element, 2)">sell</mat-icon>
                    </h6>
                    </td>
                </ng-container>
                  

                <ng-container matColumnDef="productTypeName">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Producto
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.productTypeName }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="targetName">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Finalidad
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.targetName }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="beneficiary">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Mandante
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.beneficiaryName }}</h6>
                        <h6>{{ element.rutBeneficiary }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="beneficiaryAddress">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Dirección
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.beneficiaryAddress }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="amount">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef style="min-width: 123px;">
                        Monto
                    </th>
                    <td mat-cell *matCellDef="let element" style="min-width: 123px;">
                        <h6>{{ element.currencySymbol }} {{ element.amount | number:'1.0-2' }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="price">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef style="min-width: 123px;">
                        Precio
                    </th>
                    <td mat-cell *matCellDef="let element" style="min-width: 123px;">
                        <h6>{{ simulacion.currency.symbol }}{{ element.price | number:'1.0-2' }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="discount">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Descuento
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ simulacion.currency.symbol }}{{ element.discount | number:'1.0-2' }}</h6>
                        <h6>{{ element.discountPercentage * 100 | number:'1.0-2' }}%</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="finalPrice">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef style="min-width: 123px;">
                        Precio Final
                    </th>
                    <td mat-cell *matCellDef="let element" style="min-width: 123px;">
                        <h6>{{ simulacion.currency.symbol }}{{ element.finalPrice | number:'1.0-2' }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ir">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        IR%
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ ((element.finalPrice) / (element.amount * element.currencyExchange)) * 100 | number:'1.0-2' }}%</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="rate">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Tasa
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.rate * 100 | number:'1.0-2' }}%</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="period">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Periodo
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.period }} Días</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="state">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Estado
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6 class="statusRequiere" *ngIf="element.discountPendingApproval">$ Solicitado</h6>
                        <h6 class="statusOK" *ngIf="!element.discountPendingApproval">Lista</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="expand">
                    <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                    <td mat-cell *matCellDef="let element">
                    <button mat-icon-button aria-label="expand row"
                            (click)="expandedElement = expandedElement === element ? null : element; $event.stopPropagation()">
                        <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
                        <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
                    </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
                    <div class="example-element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                        <div class="example-element-description" style="width: 100%;">
                            <div class="row">
                                <div class="col-6">
                                    <h5 style="text-decoration: underline; color: #003c8a;">Glosa</h5>
                                    <h6>{{element.gloss || 'Sin Glosa'}}</h6>
                                </div>
                                <div class="col-6">
                                    <h5 style="text-decoration: underline; color: #003c8a;">Obseraciones</h5>
                                    <h6>{{element.observations || 'Sin Observaciones'}}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    </td>
                </ng-container>
                
                <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
                <tr mat-row [cdkContextMenuTriggerFor]="menu" *matRowDef="let element; columns: columnsToDisplayWithExpand" style="cursor: pointer;"
                [ngClass]="{ 'example-expanded-row': expandedElement === element }"
                (click)="expandedElement = expandedElement === element ? null : element">

                    <ng-template #menu>
                        <div cdkMenu class="context_menu mat-elevation-z0" style="z-index: 999">
                            <span>
                                <button *ngIf="simulacion.statusId!=-7 || !element.discountPendingApproval"
                                color="primary"
                                class="context-menu-item"
                                cdkMenuItem
                                mat-flat-button
                                (click)="openRisolutionDiscount(element, 1)"
                                >
                                    Informacion
                                </button>
                                <button *ngIf="simulacion.statusId==-7 && element.discountPendingApproval"
                                color="primary"
                                class="context-menu-item"
                                cdkMenuItem
                                mat-flat-button
                                (click)="openRisolutionDiscount(element, 2)"
                                >
                                    Resolver Descuento
                                </button>
                            </span>
                        </div>
                    </ng-template>
                    
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row">
                </tr>
            </table>
        </div>
    </mat-card-content>
</mat-card>